import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, EDIT, YES } from "const"
import {
    projectBaseRoute,
    projectsRoute,
    tasksRoute,
} from "client/parts/routes"
import {
    StoreType,
    setTaskBaseRoute,
} from "client/store"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"
import List from "./list"
import View from "./view"
import Edit from "./edit"

const Task = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const dispatch = useDispatch()

    const { taskModuleAccess } = packageSettings
    const access = userData.accountId !== 1 && taskModuleAccess === YES

    const baseRouteMask = project.id ? `${projectBaseRoute}${tasksRoute}` : tasksRoute
    const baseRoute = project.id ? `${projectsRoute}/${VIEW}/${project.id}${tasksRoute}` : tasksRoute

    useEffect(() => {
        dispatch(setTaskBaseRoute(baseRoute))
    }, [])


    if (!access) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/${VIEW}/:taskId`}
                component={View}
            />
            <Route
                path={`${baseRouteMask}/${EDIT}/:taskId`}
                component={Edit}
            />
            <Route
                path={baseRouteMask}
                component={List}
            />
        </Switch>
    )
}
export default Task
